// Module
var code = "<div v-if=\"alert\" class=\"alert\" :class=\"classes\">\n  <span class=\"alert-message\">{{ alert.message }}</span>\n  <btn\n    v-if=\"alert.retryAction\"\n    @click=\"retry\"\n    icon-name=\"ion-loop\"\n    theme=\"danger\"\n    size=\"small\"\n    class=\"alert-retry-btn\">\n    Retry\n  </btn>\n</div>\n";
// Exports
export default code;